<template>
  <van-popup v-model="onShow" position="bottom" class="pay-popup">
    <van-row align="center" class="pay-header">
      <div class="pay-title">{{ title }}</div>
    </van-row>
    <div class="pay-content" v-if="items">
      <van-radio-group v-model="result">
        <van-cell-group>
          <van-cell
            v-for="(item, index) in items"
            clickable
            :key="index"
            :title="item.text"
            @click="toggle(index)"
          >
            <template #right-icon>
              <van-radio :name="item.value" ref="radioboxes" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </div>
    <div class="pay-footer">
      <van-button type="info" block @click="onClick">{{
        $t.meta.confirm
      }}</van-button>
    </div>
  </van-popup>
</template>

<script>
import Vue from "vue";
import { Popup, Row, CellGroup, Cell, RadioGroup, Radio, Button } from "vant";

Vue.use(Popup)
  .use(Row)
  .use(CellGroup)
  .use(Cell)
  .use(RadioGroup)
  .use(Radio)
  .use(Button);

export default {
  name: "RadioList",
  props: ["options", "value", "event", "title"],
  data() {
    return {
      items: [],
      onShow: false,
      result: "",
    };
  },
  watch: {
    options() {
      this.items = this.options;
    },
  },
  mounted() {
    this.$bus.$off(this.event).$on(this.event, (isShow) => {
      this.onShow = isShow;
      this.result = this.value;
    });
  },
  methods: {
    toggle(index) {
      this.$refs.radioboxes[index].toggle();
    },
    onClick() {
      this.$emit("onSelect", this.result);
      this.onShow = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";
.pay-popup {
  height: 70%;
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
  .pay-header {
    width: auto;
    padding: 5%;
    .pay-title {
      width: 100%;
      text-align: center;
      font-size: 16px;
    }
    .pay-subtitle {
      width: 100%;
      text-align: center;
      font-weight: bold;
      font-size: 2rem;
      margin-top: 0.5rem;
      .boxUnit {
        font-size: 1.5rem;
        margin-left: 4px;
        margin-right: 4px;
      }
    }
  }
  .pay-content {
    ::v-deep .van-radio__icon--checked {
      .van-icon-success {
        background-color: #0090e6 !important;
        border-color: #0090e6 !important;
      }
    }
    .nationImg {
      width: 30px;
      height: auto;
    }
  }
  .pay-footer {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);
    border-top: 1px solid #f6f6f6;
    .van-button {
      border: none;
      border-radius: 0px;
      background: -webkit-gradient(
        linear,
        left top,
        right top,
        from(#25B9FF),
        to(#0090e6)
      );
    }
  }
}
</style>